<template>
  <div class="container">
    <div class="row justify-content-center align-items-center py-2 my-3">
      <p class="page-title-header-text mb-0">Select a round below to view its leaderboard.</p>
    </div>
    <hr class="line-break">
    <div class="container fluid winnings-container">
      <table class="winnings-table">
        <tr class="table-row-header">
          <th class="table-header-text">Date</th>
          <th class="table-header-text">Round Name</th>
          <th class="table-header-text">Points</th>
          <th class="table-header-text">Place</th>
          <th class="table-header-text">Prize </th>
        </tr>
        <tr v-for="(win, index) in winningsTableData" :key="index" class="table-row-data" v-on:click="onRoundClicked(win.RoundId, win.DisplayName)">
          <td class="table-data-text">{{ formatDate(win.EndDate) }}</td>
          <td class="table-data-text">{{ win.DisplayName }}</td>
          <td class="table-data-text">{{ win.Points }}</td>
          <td class="table-data-text">{{ win.Position }}</td>
          <td class="table-data-text">{{ win.PrizeName }}</td>
          <td><BIconChevronBarRight class="chevron-bar-right"/></td>
        </tr>
      </table>
    </div>
    <div class="home-button-box">
      <button v-on:click="routeHome()" class="home-button"><p class="button-text">Home</p></button>
    </div>
  </div>
</template>

<script>
import ScorePredictorService from "../services/scorePredictorService";
import {mapState, mapMutations} from "vuex";
import moment from 'moment'
import {ActiveSports} from "@/config/activeSports";
import {BIconChevronBarRight} from 'bootstrap-vue';

export default {
  name: "YourWinings",
  components: BIconChevronBarRight,
  data() {
    return {
      winningsTableData: [],
      activeSports: ActiveSports
    }
  },
  computed: mapState(['userData', 'yourWinningsSelected']),
  methods: {
    ...mapMutations(['setIsYourWinningsSelected', 'setSelectedRound', 'setSelectedLeague', 'setSelectedSport']),

    onRoundClicked(roundId, displayName) {
      this.selectSport(displayName);
      this.selectLeague(displayName);
      this.setSelectedRound(roundId);

      this.$router.push('leaderboard')
    },
    selectSport(displayName) {
      if (displayName.includes('Soccer')) this.setSelectedSport('Soccer');
      if (displayName === 'OBFCC') this.setSelectedSport('Olympics');
    },
    selectLeague(displayName) {
      this.setSelectedLeague(displayName)
    },
    async getPlayerWinnings() {
      const playerWinnings = await ScorePredictorService.getPlayerWinnings(this.userData.msisdn);
      this.winningsTableData = playerWinnings.reverse();
    },
    setTabState() {
      this.setIsYourWinningsSelected(true);
    },
    formatDate(date) {
      return moment(date).format('DD/MM/YY');
    },
    routeHome() {
      this.setIsYourWinningsSelected(false);
      this.$router.push('/sports');
    },
    clearState() {
      this.winningsTableData = [];
    }
  },
  mounted() {
    this.setTabState();
    this.clearState();
    this.getPlayerWinnings()
  }
}
</script>

<style scoped lang="scss">
.winnings-container {
  display: flex;
  width: 90vw;
  background-color: rgba(129, 124, 124, 0.8);
  box-shadow: 0 0.5rem 1rem 0 rgba(0,0,0,.7),
  0 -0.25rem 1.5rem $winnings-table-background inset,
  0 0.75rem 0.5rem rgba(255, 255, 255, 0.4) inset,
  0 0.25rem 0.5rem 0 #ffffff inset;
  padding: 0.6rem 1rem 1.5rem 1rem;
  border-radius: 3px;
}

.chevron-bar-right {
  color: $current-predictions-home-button;
}

.winnings-table {
  width: 100%;
}

.table-row-data:hover {
  background-color: rgba(80, 80, 80, 0.8);
  cursor: pointer;
}

.table-row-data {
  height: auto;
  border-bottom: 1px solid #5d5d5d;
}

.table-row-header {
  border-bottom: 1px solid #5d5d5d;
}

.table-header-text {
  text-align: center;
  vertical-align: middle;
  font-size: 1rem;
  color: $winners-table-header-text-color;
  padding: 1.2rem 0;
  font-weight: 600;
}

.table-data-text {
  text-align: center;
  vertical-align: middle;
  font-size: 0.8rem;
  color: $winners-table-data-text-color;
  padding: 1rem 0;
}

@media screen and (max-width: 380px) {
  .table-header-text {
    font-size: 0.8rem;
  }

  .table-data-text {
    font-size: 0.6rem;
  }
}

@media screen and (max-width: 280px) {
  .table-header-text {
    font-size: 0.7rem;
  }

  .table-data-text {
    font-size: 0.5rem;
  }
}

.home-button-box {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 0;
  margin-right: 0;
  padding: 0;
  margin-top: 2vh;
}

.home-button {
   display: flex;
   justify-content: center;
   align-items: center;
   height: 8vh;
   width: 300px;
   border: solid $transperent-button-border-color 2px;
   border-radius: 5px;
   background-color: Transparent;
   z-index: 0;
   margin-bottom: 2vh;
 }

.back-button {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 8vh;
  width: 300px;
  border-radius: 5px;
  background-color: Transparent;
  z-index: 0;
  margin-bottom: 2vh;
}

.button-text {
  color: $button-text-color;
  font-size: large;
  padding: 0;
  margin: 0;
}

.line-break {
  color: $line-break-color;
}

</style>
